<template>
  <div id="map-view">
    <div id="map"></div>
    <vs-popup fullscreen :title="vesselTankerDetail.name" :active.sync="active">
      <div class="vx-row">
        <div class="vx-col mb-base sm:w-1/3 lg:w-1/3 xl:w-1/3">
          <vx-card class="mb-base">
            <card-stock
              :value="this.getValue(this.transferData)"
              :lastValue="this.getLastValue(this.transferData)"
              :date="convertDate(date)"
            />
          </vx-card>
          <vx-card class="mb-base">
            <div id="chart">
              <compair-chart :transferData="convertDataChart(mpTransfer)" />
            </div>
          </vx-card>
        </div>
        <div class="vx-col mb-base app-fixed-height sm:w-2/3 lg:w-2/3 xl:w-2/3">
          <vx-card style="height: 550px">
            <div class="vx-row">
              <div class="vx-col">
                <card-price
                  :title="$t('TankerTable.Capacity')"
                  :value="getTankerDetailValue()"
                />
              </div>
              <div class="vx-col">
                <card-price
                  :title="$t('TankerTable.TransferVolume')"
                  :value="getMpTankerValue()"
                />
              </div>
            </div>
            <tanker
              :active="active"
              :width="750"
              :height="250"
              :value="getPercentage()"
            />
          </vx-card>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import "moment/locale/th";
import { mapState, mapGetters } from "vuex";
import gmapsInit from "@/gmap/gmap";
import CardPrice from "@/common/Card/CardPrice";
import CompairChart from "@/common/Charts/CompairChart";
import { VESSELS_TYPE } from "./../../constant";
import { chartOptions } from "./chart";
import CardStock from "@/common/CardStock";
import Tanker from "@/components/Tanker/Tanker";
import { refinery } from "./location";
import all from "../../milesSea/all.json";

export default {
  components: {
    CompairChart,
    CardStock,
    Tanker,
    CardPrice,
  },
  name: "MapView",
  props: {
    type: {
      type: String,
      default: VESSELS_TYPE.EXCISE,
    },
    date: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      active: false,
      google: null,
      windowInfo: null,
      zoom: 8,
      markers: [],
      vesselTankerDetail: {},
      chartOptions: chartOptions,
      refinery,
      transferData: [],
      all,
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.vesselTanker.data,
      loading: (state) => state.vesselTanker.loading,
      focusId: (state) => state.vesselTanker.focusId,
      error: (state) => state.vesselTanker.error,
      refname: (state) => state.greenDieselCardActive.refineryName,
      mpTanker: (state) => state.mpTankerData.mpTanker,
      mpTransfer: (state) => state.mpTankerData.mpTankerCapacity,
      mpTankerValue: (state) => state.mpTankerData.mpTankerValue,
      vesselTrip: (state) => state.vesselTrip.data,
    }),
    ...mapGetters({
      getterCapacity: "getCapacity",
      getterTransferValue: "getTransferValue",
      getterTankerValue: "getTankerValue",
    }),
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    data(val) {
      if (_.isEmpty(val)) {
        return;
      }
      this.renderVessel(val);
    },
    focusId(val, oldval) {
      if (!_.isEqual(val, oldval) && val) {
        this.panTo(val);
      }
    },
    refname(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        this.panToRef(val);
      }
    },
    vesselTankerDetail(val) {
      // onClink tanker
      const { mmsi } = val;
      this.getTankerByMMSI(mmsi);
      this.getMpTankerVolume(mmsi);
    },
    mpTanker(val) {
      if (!_.isEmpty(val)) {
        this.getMpTankerDetail(val);
      }
    },
    mpTransfer(val) {
      if (!_.isEmpty(val)) {
        this.transferData = this.convertDataChart(val);
      }
    },
  },
  mounted() {
    this.initGoogleMap();
    this.$store.dispatch("getVessel", { type: this.type });
    this.$store.dispatch("getVesselTrip", this.date);
    // console.log(this.vesselTrip);
  },
  methods: {
    async initGoogleMap() {
      const google = await gmapsInit();
      this.geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(13.7772995, 100.5255274);
      const options = {
        zoom: this.zoom,
        center: latlng,
        streetViewControl: false,
        mapTypeControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        fullscreenControl: true,
        gestureHandling: "greedy",
        zoomControl: true,
      };
      this.map = new google.maps.Map(this.$el.querySelector("#map"), options);
      this.google = google;

      this.map.data.addGeoJson(this.all);
      this.map.data.setStyle((feature) => {
        var color = feature.getProperty("color");
        if (color == "red") {
          color = "red";
        } else if (color == "green") {
          color = "#10FD1E";
        } else if (color == "blue") {
          color = "#00BDFF";
        }
        return {
          clickable: false,
          fillColor: color,
          strokeWeight: 0,
        };
      });

      // render refinaty
      this.renderRefinery();
    },
    getDirection(direction) {
      const n = direction % 10 ? 0 : 1;
      const tpye = Math.ceil(direction / 10) + n;
      return tpye > 36 ? 10 : tpye;
    },
    getVesselImg(vessel) {
      const imgShip = "excise";
      const direction = _.get(vessel, "hdg_cog", 360);
      const shipType = vessel.navigation_status_code == "0" ? "b" : "";
      const imgDirection = this.getDirection(direction);
      const imageUrl = `/assets/markers/${imgShip}/${shipType}${imgDirection}.png`;
      return imageUrl;
    },
    renderVessel(val) {
      const { google, map } = this;
      val.map((vessel, i) => {
        const latitude = _.get(vessel, "latitude");
        const longitude = _.get(vessel, "longitude");
        const latlng = new google.maps.LatLng(latitude, longitude);

        const imageUrl = this.getVesselImg(vessel);
        const markerImage = this.createMarkerIcon(imageUrl);

        const marker = new google.maps.Marker({
          position: latlng,
          map,
          icon: markerImage,
          detail: { ...vessel, idg: i },
        });
        const vm = this;
        google.maps.event.addListener(marker, "click", function () {
          vm.openLoading();
          map.setZoom(9);
          map.setCenter(marker.getPosition());
          vm.active = true;
          vm.vesselTankerDetail = marker.detail;
        });
        this.markers.push(marker);
      });
    },
    getMpTankerVolume(mmsi) {
      this.$store.dispatch("getMpTankerVolume", {
        date: this.date,
        destination_type: "transit",
        isDomestic: "false",
        mmsi,
      });
    },
    getTankerByMMSI(mmsi) {
      this.$store.dispatch("getMpTankerByMMSI", { mmsi });
    },
    async getMpTankerDetail(tankerDetail) {
      const id = _.get(tankerDetail, "id");
      await this.$store.dispatch("getMpCapacityDetail", {
        id,
        date: this.date,
      });
    },
    renderRefinery() {
      for (let i = 0; i < this.refinery.length; i++) {
        const latitude = this.refinery[i].latitude;
        const longitude = this.refinery[i].longitude;

        const { google, map } = this;
        const latlng = new google.maps.LatLng(latitude, longitude);
        const imageUrl = this.refinery[i].imageUrl;
        const markerImage = this.createMarkerIcon(imageUrl);

        const marker = new google.maps.Marker({
          position: latlng,
          map,
          icon: markerImage,
          detail: { ...refinery },
        });
        this.markers.push(marker);
      }
    },
    createMarkerIcon(imageUrl) {
      const google = this.google;
      const markerImage = new google.maps.MarkerImage(
        imageUrl,
        new google.maps.Size(30, 30),
        new google.maps.Point(0, 0),
        new google.maps.Point(20, 20),
        new google.maps.Size(30, 30)
      );
      return markerImage;
    },
    panTo(id) {
      const google = this.google;
      this.markers.map((val) => {
        const { detail } = val;
        if (detail.mmsi == id) {
          this.map.panTo(val.getPosition());
          this.windowInfoClose();
          this.windowInfo = new google.maps.InfoWindow({
            content: detail.name,
            position: val.getPosition(),
          });
          this.windowInfo.open(this.map);
        }
      });
    },
    panToRef(name) {
      const google = this.google;
      for (let i = 0; i < this.refinery.length; i++) {
        if (this.refinery[i].name == name) {
          const latitude = this.refinery[i].latitude;
          const longitude = this.refinery[i].longitude;
          const latlng = new google.maps.LatLng(latitude, longitude);
          this.map.panTo(latlng);
          this.windowInfoClose();
          this.windowInfo = new google.maps.InfoWindow({
            content: `Refinery: ${name}`,
            position: latlng,
          });
          this.windowInfo.open(this.map);
        }
      }
      if (name == "ยอดรวมน้ำมัน") {
        const latitude = 13.7772995;
        const longitude = 100.5255274;
        const latlng = new google.maps.LatLng(latitude, longitude);
        this.map.panTo(latlng);
        this.windowInfoClose();
        this.windowInfo = new google.maps.InfoWindow({
          content: `CENTER`,
          position: latlng,
        });
        this.windowInfo.open(this.map);
      }
      this.$store.dispatch("panTo", 0);
    },
    windowInfoClose() {
      if (this.windowInfo) {
        this.windowInfo.close();
      }
    },
    getTankerDetailValue(isCapacity = true) {
      const value = isCapacity
        ? this.getterCapacity()
        : this.getterTransferValue();
      if (typeof value == "string") {
        return Number(value.replace(/[^0-9.-]+/g, ""));
      }
      return value;
    },
    getPercentage() {
      const total = this.getTankerDetailValue();
      const value = this.getTankerDetailValue(false);
      if (value > total) return 100;
      if (total == 0) return 0;
      return 100 - ((total - value) / total) * 100;
    },
    convertDate(date) {
      let st = moment(date.startDate, "DD/MM/YYYY");
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const year = parseInt(st.format("YYYY")) + 543;
        st = `${st.locale(locale).format("DD MMMM")} ${year}`;
      } else {
        st = st.locale('en').format("MMM Do YYYY");
      }

      if (date.startDate == date.endDate) {
        return st;
      }

      let ed = moment(date.endDate, "DD/MM/YYYY");
      if (locale == "th") {
        const year = parseInt(ed.format("YYYY")) + 543;
        ed = `${ed.locale(locale).format("DD MMMM")} ${year}`;
      } else {
        ed = ed.locale('en').format("MMM Do YYYY");
      }
      return `${st} - ${ed}`;
    },
    getValue(data) {
      if (data.length > 0) {
        const value = _.get(this.getLast(data, 1)[0], "value1", 0);
        return value;
      }
      return 0;
    },
    getLastValue(data) {
      if (data.length > 0) {
        const value = _.get(this.getLast(data, 2)[0], "value1", 0);
        return value;
      }
      return 0;
    },
    getLast(arr = null, n = null) {
      if (arr == null) return 0;
      if (n === null) return arr[arr.length - 1];
      return arr.slice(Math.max(arr.length - n, 0));
    },
    convertDataChart(data) {
      if (data.length) {
        const newData = data
          .map((transferData) => ({
            date: new Date(transferData.statement_date),
            value1: Math.abs(Number(transferData.total_transfer)),
          }))
          .slice()
          .sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
        return newData;
      }
      return [];
    },
    getMpTankerValue() {
      return this.getterTankerValue();
    },
    openLoading() {
      this.$vs.loading();
      setTimeout(() => {
        this.$vs.loading.close();
      }, 2000);
    },
  },
};
</script>
<style scoped>
#map {
  position: relative;
  width: 100%;
  height: 100%;
}
#map-view {
  width: 100%;
  height: 100%;
}
</style>
